import makeQueryHook from 'core/types/makeQueryHook'
import { render } from 'core/types/operations'

const useRenderToDownload = makeQueryHook({
  ...render,
  queryKey: ({ body, ...parameters }) => render.queryKey({ ...parameters, query: body }),
} as unknown as typeof render)

export default useRenderToDownload
